export const PermissionConst = {
  Read: 0,
  Write: 1,
  Share: 2,
  Delete: 3,
  ImportElements: 4,
  PassOwnerShip: 5
};
